import type { EnrollmentFormData, EnrollmentSnapshot } from './enrollmentState.types'

export const initialFormData: EnrollmentFormData = {
  firstName: '',
  lastName: '',
  middleName: '',
  email: '',
  phone: '',
  phoneNumber: '',
  dateOfBirth: '',
  birthDate: '',
  ssn: '',
  address: '',
  addressLine1: '',
  addressLine2: '',
  city: '',
  state: '',
  zipCode: '',
  licenseNumber: '',
  licenseState: '',
  licenseExpiration: '',
  licenseClass: 'CLASS_A',
  hasEndorsements: false,
  endorsementTypes: [],
  transmissionType: 'AUTOMATIC',
  hasExperience: false,
  experienceYears: 0,
  hasViolations: false,
  violationDetails: '',
  hasMedicalCard: false,
  medicalCardExpiration: '',
  emergencyContactName: '',
  emergencyContactPhone: '',
  emergencyContactRelation: '',
  about: '',
  howDidYouHear: '',
  referralSource: '',
  referredBy: '',
  appointmentDate: '',
  appointmentTime: '',
  preferredCallTime: '',
  notes: '',
  termsAccepted: false,
  smsConsent: false,
  marketingConsent: false,
  contactExternalId: '',
  locationExternalId: '',
  locationState: '',
  programExternalId: '',
  programYardOnly: false,
  programClassOnly: false,
  quoteToken: '',
  applicationReadyAt: null
}

export const initialEnrollmentSnapshot: EnrollmentSnapshot = {
  enrollmentId: null,
  sessionToken: null,
  currentStep: 0,
  enrollmentPath: null,
  locationId: null,
  programId: null,
  startDateId: null,
  formData: initialFormData,
  uploadedDocumentFiles: {},
  assessmentId: null,
  signatureCompleted: false,
  enrollmentCompleted: false
}
